<template>
    <div class="card">
        <div class="card-header font-weight-bold">
            Banners
            <button
                type="button"
                v-tooltip.bottom-start="'Refrescar'"
                class="btn btn-success btn-sm"
                @click="refreshList"
            >
                <em class="fa fa-refresh"></em>
            </button>
        </div>
        <div class="card-body">
            <div v-if="loading_" class="text-center">
                <stretch></stretch>
                <p class="text-center mt-2">Procesando</p>
            </div>

            <p class="text-center mt-2" v-if="!existBanners && !loading_">
                Aún no hay ningún banner registrado.
            </p>

            <table class="table table-borderless" v-if="existBanners">
                <thead>
                    <tr>
                        <th scope="col">Opciones</th>
                        <th scope="col">Orden</th>
                        <th scope="col">Título</th>
                        <th scope="col">Fecha Creación</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="banner in banners" v-bind:key="banner.id">
                        <td>
                            <div class="flex-btn">
                                <button
                                    type="button"
                                    v-tooltip.bottom-start="'Editar'"
                                    class="btn btn-warning btn-sm"
                                    @click="changeView(banner.id)"
                                >
                                    <em class="fa fa-pencil"></em>
                                </button>

                                <button
                                    type="button"
                                    v-tooltip.bottom-start="'Eliminar'"
                                    class="btn btn-danger btn-sm"
                                    @click="confirmDeleteBanner(banner.id)"
                                >
                                    <em
                                        class="fa fa-trash-o"
                                        aria-hidden="true"
                                    ></em>
                                </button>
                            </div>
                        </td>
                        <td>{{ banner.order }}</td>
                        <td>{{ banner.title }}</td>
                        <td>{{ banner.created_at }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import { Stretch } from "vue-loading-spinner";
import helpers from "../../mixins/index";

export default {
    name: "SectionPrehomeBannerList",
    mixins: [helpers],
    props: ["bannerId"],
    components: {
        stretch: Stretch,
    },
    data() {
        return {
            banners: [],
            loading_: false,
        };
    },
    computed: {
        existBanners() {
            return this.banners.length > 0;
        },
    },
    methods: {
        getBanners() {
            const me = this;
            me.banners = [];
            me.loading_ = true;

            axios
                .get("/api/banners?type=prehome")
                .then(function (response) {
                    const { data } = response.data;
                    me.banners = data;
                })
                .catch(function (error) {
                    me.showSwalError(
                        "No fue posible procesar su solicitud, intente mas tarde."
                    );
                })
                .finally(() => {
                    me.loading_ = false;
                });
        },

        confirmDeleteBanner(bannerId) {
            const me = this;
            this.$swal({
                title: `Esta seguro de eliminar el banner con ID ${bannerId}`,
                text: "No podrás revertir esto!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#1c8eb7",
                cancelButtonColor: "#6c757d",
                confirmButtonText: "Si, Borrar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.isConfirmed) {
                    me.deleteBanner(bannerId);
                }
            });
        },

        deleteBanner(bannerId) {
            const me = this;
            me.loading();
            axios
                .delete(`/api/banners/${bannerId}`, {
                    order: me.orderBanners,
                })
                .then(function (response) {
                    me.closeLoading();
                    me.showActionSuccess("Banner eliminado");
                    me.refreshList();
                })
                .catch(function (error) {
                    me.showSwalError(
                        "No fue posible procesar su solicitud, intente mas tarde."
                    );
                });
        },

        changeView(bannerId) {
            this.$emit("change-view", bannerId);
        },

        refreshList() {
            setTimeout(() => {
                this.getBanners();
            }, 200);
        },
    },
    mounted() {
        this.getBanners();
    },
};
</script>
